import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png"
// css
import styles from "./ConfirmationPop.module.scss";

const ConfirmationPopup = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmBtnText,
  cancelBtnText,
}) => {

  return (
    <div className="">
      <Modal
        show
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="text-center mx-auto">
            <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "rgb(49, 93, 153)" }}>
              <h3 className={`${styles.modalMessage} mb-0 pb-0 section-title border-bottom-0`} style={{ color: "rgb(49, 93, 153)", fontSize: "14px" }}>
                {title || "Are you sure?"}
              </h3>
              <img onClick={onCancel} width={16} height={16} src={crossIcon} alt="crossIcon" style={{ cursor: "pointer" }} />
            </div>
            <p className="my-2 proxmia-thin text-start fw-bold" style={{ fontSize: "16px", color: "#505C6D" }}>{message || ""}</p>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={onCancel}
                  className={`${styles.modalButton} proxima-regular `}
                  style={{
                    border: "1px solid rgb(49, 93, 153)",
                    background: "white",
                    color: "#315D99",
                    padding: "8px 38px",
                    borderRadius: 2,
                  }}
                >
                  {cancelBtnText || "No"}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={onConfirm}
                  className={`${styles.modalButton} proxima-regular`}
                  style={{
                    backgroundColor: "rgb(49, 93, 153)",
                    color: "#fff",
                    padding: "8px 38px",
                    borderRadius: 2,
                    border: 0,
                  }}
                >
                  {confirmBtnText || "Yes"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfirmationPopup;